import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const checkPersonNumber = nr => {
  return dispatch => {
    dispatch({ type: "CHECK_PERSON_NUMBER_LOADING" });
    api
      .personNumberCheck(nr)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "CheckPersonNumberAlertTitle",
          "Virhe tarkistaessa henkilönumeroa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "CHECK_PERSON_NUMBER_SUCCEEDED",
  payload: { personNumberCheckResult: data }
});

const operationFail= () => ({
  type: "CHECK_PERSON_NUMBER_FAIL"
});